import { render, staticRenderFns } from "./video-btn-group.vue?vue&type=template&id=04232d92&scoped=true&"
import script from "./video-btn-group.vue?vue&type=script&setup=true&lang=ts&"
export * from "./video-btn-group.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./video-btn-group.vue?vue&type=style&index=0&id=04232d92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04232d92",
  null
  
)

/* custom blocks */
import block0 from "./video-btn-group.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports